import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import AppCard from "../../components/appCard";
import { ImagemLogo } from "../../components/imagensDinamicas";
import { Api } from "../../services/api";
import { ButtonPagueDefault } from "../../styles/primeReactConfig";

function ResetSenha() {
    const navigate = useNavigate();
    const [documentReset, setDocumentReset] = useState();
    const [emailReset, setEmailReset] = useState();

    const resetPassword = async (event) => {
        event.preventDefault()
        try {
            await Api.post('login/novasenha', { usuario_documento: unMask(documentReset), usuario_email: emailReset });

            toast.success("Um email com informações da sua senha será enviado para o email do usuário!")
        } catch (error) {
            console.log(error)
            toast.error('Erro ao resetar a senha')
        }
    }

    return (
        <div style={{ display: 'grid', background: `url(${'/2.png'}) no-repeat`, alignItems: "center", backgroundSize: "cover", height: "100vh", width: "100%", overflowX: "hidden" }}>
            <div className="z-1 p-2 absolute top-0" >
                <Button icon={<FaArrowLeft />}
                    rounded
                    tooltip="Voltar à página inicial"
                    onClick={() => { navigate('/') }} />
            </div>
            <div className="grid">
                <div className="w-full justify-center flex">
                    <AppCard className="w-full md:w-1/2 lg:w-1/3 bg-blue-100 text-indigo-900 text-center ">
                        <form onSubmit={(e) => resetPassword(e)}>
                            <div className="w-full flex justify-center">
                                <ImagemLogo />
                            </div>
                            <h3 className="text-xl mt-6"><b>Recuperar Senha</b></h3>
                            <p>Parece que você esqueceu sua senha, para recuperá-la precisamos de informações do seu usuário</p>
                            <div className="grid text-left mt-4 px-2">
                                <label htmlFor="documento">CPF/CNPJ</label>
                                <InputText
                                    id="documento"
                                    value={documentReset}
                                    required
                                    type='text'
                                    onChange={e => {
                                        setDocumentReset(
                                            mask(unMask(e.target.value), [
                                                '999.999.999-99',
                                                '99.999.999/9999-99',
                                            ]))
                                    }}
                                >
                                </InputText>
                                <label htmlFor="email">Email</label>
                                <InputText
                                    id="email"
                                    type='email'
                                    value={emailReset}
                                    required
                                    onChange={e => { setEmailReset(e.target.value) }}
                                >
                                </InputText>
                            </div>
                            <div className=" flex mt-6 justify-center p-2">
                                <div className="w-full lg:w-2/3">
                                    <Button
                                        className="w-full"
                                        pt={ButtonPagueDefault}
                                        type="submit"
                                        label="Continuar"
                                    />
                                </div>
                            </div>
                        </form>
                    </AppCard>
                </div>
            </div>
        </div>
    )
}

export default ResetSenha